import React from 'react';
import { useProto } from '../../contexts/PrototypeContext';
import { Toggle } from '../shared/Toggle';
import { FieldTag } from '../shared/FieldTag';
import { Annotation } from '../shared/Annotation';
const offerLabel = {
  discount: 'Volunteer Registration Discount',
  coachCredit: 'Automated Coach Credit',
  none: 'Standard volunteer messaging (no incentive)'
};
export function CoachCreditSetting() {
  const {
    state,
    summary,
    actions
  } = useProto();
  const {
    config
  } = state;
  const showing = config.discountEnabled && config.amount > 0 && summary.available > 0 ? 'discount' : config.coachCreditEnabled ? 'coachCredit' : 'none';
  return <section aria-labelledby="other-incentives" data-id="element-11" data-mp="16fyh0048nqm9">
      <div className="flex items-end justify-between border-b border-connect-line pb-1.5" data-id="element-12" data-mp="16e3y0rcj28kt">
        <h3 id="other-incentives" className="text-[17px] font-medium text-connect-blue" data-id="element-13" data-mp="iojb5xd96r69">Other Volunteer Incentives</h3>
        <span className="text-xs text-connect-muted" data-id="element-14" data-mp="dowxxnxfdaxg">Existing setting</span>
      </div>
      <div className="mt-5 flex items-start justify-between gap-6" data-id="element-15" data-mp="21864qo8zmkci">
        <div data-id="element-16" data-mp="259hrmm0h8rh0">
          <label htmlFor="coach-credit" className="font-medium text-connect-ink" data-id="element-17" data-mp="258ygbo5c11by">Automated Coach Credit</label>
          <p className="mt-0.5 max-w-xl text-sm text-connect-muted" data-id="element-18" data-mp="2a1j86k4oh4cu">
            Eligible coaches may earn a credit toward a future season after meeting coaching and background-check requirements. Separate from the immediate registration discount.
          </p>
        </div>
        <Toggle id="coach-credit" checked={config.coachCreditEnabled} onChange={v => actions.updateConfig({
        coachCreditEnabled: v
      })} data-id="element-19" data-mp="1mcgicozw4579" />
      </div>
      <div className="mt-4 flex items-center gap-2 text-sm" data-id="element-20" data-mp="1rcusccl1xp7x">
        <span className="text-connect-muted" data-id="element-21" data-mp="1wae3h3mgdlvn">Customers currently see:</span>
        <span className="font-medium text-connect-ink" data-id="element-22" data-mp="32qgfjs7cpgqt">{offerLabel[showing]}</span>
        <FieldTag kind="calculated" data-id="element-23" data-mp="37ohxuawydc18" />
      </div>
      <Annotation kind="rule" title="Never show both offers" className="mt-3" data-id="element-24" data-mp="37n6ugc7f66an">
        Customers see one offer card. An available Volunteer Registration Discount takes precedence; otherwise Automated Coach Credit displays when enabled.
      </Annotation>
    </section>;
}